import React from "react";
import Button from "../../../../../../../common/Button";

const KeypadChangeButton = ( props ) => {

  return (
    <Button className="pen btn-chg-num" onClick={ props.onChangeKeypad }>
      <img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_num.svg` } alt="" />
    </Button>
  );

};

export default KeypadChangeButton;
